import { render } from "./SchoolLicenseManageInvalidTable.vue?vue&type=template&id=09b8f5e5&scoped=true"
import script from "./SchoolLicenseManageInvalidTable.vue?vue&type=script&lang=js"
export * from "./SchoolLicenseManageInvalidTable.vue?vue&type=script&lang=js"

import "./SchoolLicenseManageInvalidTable.vue?vue&type=style&index=0&id=09b8f5e5&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hagino\\work\\src\\plus-manabi\\mplus-front\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09b8f5e5"]])

export default __exports__